import { render, staticRenderFns } from "./RelatorioGraphs.vue?vue&type=template&id=33152d58&"
import script from "./RelatorioGraphs.vue?vue&type=script&lang=js&"
export * from "./RelatorioGraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports